import React, { useState, useEffect } from "react";
import { Button, Form, Input, Card, message } from "antd";
import trans from "./../../../Languages/Languages";
import API from "../../../API";
import { usePageContext } from "../../../Context/PageContext";

const ContactUS = () => {
  const [loading, setLoading] = useState(true);
  const [contactUsData, setContactUsData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [errors, setErrors] = useState({});


  const [contactUsLabel, setContactUsLabel] = useState(null);
  const [administratorAddressLabel, setAdministratorAddressLabel] = useState(null);
  const [kingdomSAlabel, setKingdomSAlabel] = useState(null);

  const [renamingSection, setRenamingSection] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
  const { triggerRefresh } = usePageContext();


  // Use Effect
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/contactus")
        .then((res) => {

          setContactUsLabel(res.data.contactUsLabel);
          setRenameValue(res.data.contactUsLabel?.title);
          setAdministratorAddressLabel(res.data.administratorAddressLabel);
          setKingdomSAlabel(res.data.kingdomSAlabel);

          setContactUsData(res.data?.contact);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();
  }, [refresh]);

  // update record
  const handleSectionSave = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("po_box", values.poBox);
    formData.append("city", values.city);
    formData.append("email", values.email);
    formData.append("fax", values.fax);

    await API.post(`/admin/contactus/update`, formData)
      .then((res) => {
        setRefresh(!refresh);
        setLoading(false);
        setErrors({});
        message.success("Updated Successfully");
      })
      .catch((e) => {
        setErrors(e.response.data);
        setLoading(false);
      });
  };

  // Hide context menu on outside click
  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleRenameSubmit = async () => {
    const section = editingSection;
    const page =
      section === "contactUsLabel"
        ? contactUsLabel
        : section === "administratorAddressLabel"
          ? administratorAddressLabel
          : kingdomSAlabel;

    try {
      await API.put(`/admin/pages/slug/${page.slug}`, { title: renameValue });

      if (section === "contactUsLabel") {
        setContactUsLabel((prev) => ({ ...prev, title: renameValue }));
      } else if (section === "administratorAddressLabel") {
        setAdministratorAddressLabel((prev) => ({ ...prev, title: renameValue }));
      } else if (section === "kingdomSALabel") {
        setKingdomSAlabel((prev) => ({ ...prev, title: renameValue }));
      }

      setRenamingSection(null);
      setEditingSection(null);
      triggerRefresh();
    } catch {
      message.error("Rename failed");
    }
  };

  const handleTitleRightClick = (e, sectionKey, label) => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
    setEditingSection(sectionKey);
    setRenameValue(label?.title);
  };

  const handleTitleDoubleClick = (sectionKey, label) => {
    setRenamingSection(sectionKey);
    setRenameValue(label?.title);
    setEditingSection(sectionKey);
  };

  const renderEditableTitle = (sectionKey, label, fallbackText) => (
    <div
      className="fw-600 fw-15 mb-2"
      onDoubleClick={() => handleTitleDoubleClick(sectionKey, label)}
      onContextMenu={(e) => handleTitleRightClick(e, sectionKey, label)}
    >
      {renamingSection === sectionKey ? (
        <input
          type="text"
          value={renameValue}
          autoFocus
          onChange={(e) => setRenameValue(e.target.value)}
          onBlur={handleRenameSubmit}
          onKeyDown={(e) => e.key === "Enter" && handleRenameSubmit()}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        label?.title || fallbackText
      )}
    </div>
  );


  return (
    <div className="pages-container">
      <div className="content-wrapper contact-us-content">
        {renderEditableTitle("contactUsLabel", contactUsLabel, trans.Contactus)}
        <Card bordered={false} className="p-0" loading={loading}>
          {contactUsData && (
            <Form onFinish={handleSectionSave}>
              <div className="f-12 fw-500 mb-3">
                {trans.KnowledgeInternationalUniversity}
              </div>
              {/* content */}
              <div className="bg-content-container mb-4">
                <div className="accordion-detail ">

                  <div className="f-12 fw-500 faculty-heading contact-main-heading">
                    {renderEditableTitle("administratorAddressLabel", administratorAddressLabel, trans.AdministratorAddress)}
                  </div>
                  <div className="d-flex justify-content-start align-items-baseline">
                    <div className="f-12 fw-500 faculty-heading contact-us-heading">
                      {trans.POBox}
                    </div>
                    <Form.Item name="poBox" initialValue={contactUsData.po_box}>
                      <Input type="text" />
                    </Form.Item>
                    {errors?.po_box && (
                      <span className="text-danger">{errors?.po_box}</span>
                    )}
                  </div>
                  <div className="d-flex justify-content-start align-items-baseline">
                    <div className="f-12 fw-500 faculty-heading contact-us-heading">
                      {trans.City}
                    </div>
                    <Form.Item name="city" initialValue={contactUsData.city}>
                      <Input type="text" />
                    </Form.Item>
                    {errors?.city && (
                      <span className="text-danger">{errors?.city}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="bg-content-container ">
                <div className="accordion-detail ">
                  <div className="f-12 fw-500 faculty-heading contact-main-heading">
                    {renderEditableTitle("kingdomSALabel", kingdomSAlabel, trans.KingdomofSaudiArabia)}
                  </div>
                  <div className="d-flex justify-content-start align-items-baseline">
                    <div className="f-12 fw-500 faculty-heading contact-us-heading">
                      {trans.Email}
                    </div>
                    <Form.Item name="email" initialValue={contactUsData.email}>
                      <Input type="text" />
                    </Form.Item>
                    {errors?.email && (
                      <span className="text-danger">{errors?.email}</span>
                    )}
                  </div>
                  <div className="d-flex justify-content-start align-items-baseline">
                    <div className="f-12 fw-500 faculty-heading contact-us-heading">
                      {trans.Fax}
                    </div>
                    <Form.Item name="fax" initialValue={contactUsData.fax}>
                      <Input type="text" />
                    </Form.Item>
                    {errors?.fax && (
                      <span className="text-danger">{errors?.fax}</span>
                    )}
                  </div>
                </div>
              </div>
              {/* save changes */}

              <Button
                className="btn-save-changes"
                type="primary"
                htmlType="submit"
              >
                {trans.Save}
              </Button>
            </Form>
          )}
        </Card>
        {/* Context Menu */}
        {showContextMenu && (
          <ul
            style={{
              position: "fixed",
              top: contextMenuPos.y,
              left: contextMenuPos.x,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: 4,
              listStyle: "none",
              padding: "5px 10px",
              margin: 0,
              zIndex: 1000,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
            onClick={() => {
              setRenamingSection(editingSection);
              setShowContextMenu(false);
            }}
            onMouseLeave={() => setShowContextMenu(false)}
          >
            <li>{trans.Rename}</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default ContactUS;
